namespace advisorop.components.advisor {
    //'use strict';
    export enum AW_Step {
        BASIC_INFORMATION = 10,
        DEFINE_OUTSIDE_HOLDINGS = 20,
        DEFINE_RTG = 30,
        INVESTMENT_PROPOSAL = 40,
        OPEN_ACCOUNT = 50
    }

    export class NewAccountWizController {

        $router;
        account: domains.IAccount = { id: 0, manualAccount: {}, investors: [] };

        // we don't use this variable, so probably we need to remove it
        initializing: boolean = true;

        // this one is in use
        isInitializing: boolean = false;

        lovs: Array<domains.ILOV> = [];

        step: number = AW_Step.BASIC_INFORMATION;
        AW_Step = AW_Step;
        InvestmentType = domains.InvestmentType;

        hasRtgHoldings: boolean = false;
        selectedSkippOption: boolean;

        // subscription doc
        uploadUrl: string = "/api/advisor/uploadaccountdocument/1314/18";
        fuValue: any[] = [];
        fuOptions: DevExpress.ui.dxFileUploaderOptions;

        //custodian and office range / master account variables
        selCustodian: domains.ICustodianAdvisoryFirm;
        selOfficeRange: domains.ICustodianAdvisoryFirmOfficeRange;
        custodians: domains.ICustodianAdvisoryFirm[] = [];
        officeRanges: domains.ICustodianAdvisoryFirmOfficeRange[] = [];

        // custodian account
        createNewCustodianAccount: boolean = false;
        selCustodianAccount: domains.IAccount;
        custodianAccounts: domains.IAccount[];
        custodianAccountsSelections: domains.IAccount[];
        custodianAccount: domains.IAccount = {
            id: 0, manualAccount: {}, investors: [], isNumberReserved: false, isDiscretionDocumentationOnFile: false, sweepFundsPercent: 0
        };
        custodianAccountIsDirty: boolean = false;
        beneficiariesAreDirty: boolean = false;
        sweepIsOn: boolean = false;
        hideHoldingsGrid: boolean = false;
         
        //supplemental fields
        sourcesOfInitialFunds: domains.ILOV[];
        selSourceOfInitialFunds: domains.ILOV;
        pricingTypes: domains.ILOV[];
        selPricingType: domains.ILOV;
        brokerageTypes: domains.ILOV[];
        selBrokerageType: domains.ILOV;
        sweepStatuses: domains.ILOV[];
        selSweepStatus: domains.ILOV;
        selCustStateGiftGiven: domains.ILOV;
        selCustMannerOfGift: domains.ILOV;
        custStateGiftGiven: Array<domains.ILOV> = [];
        custMannerOfGifts: Array<domains.ILOV> = [];
        countries: domains.ILOV[];
        selUsOfficialOfficeCountry: domains.ILOV;
        usCountryCode: string = "US";
        selJointTenancyState: domains.ILOV;
        jointTenancyState: Array<domains.ILOV> = [];

        //repfee group
        repfeeGroups: domains.IRepFeeGroup[] = [];
        selRepfeeGroup: domains.IRepFeeGroup;
        repGroupFeeOptions: domains.RepGroupFeeOptions = domains.RepGroupFeeOptions.WITH_FEES;

        // RTQ
        rtqs: Array<domains.IRTQ> = [];
        rtq: domains.IRTQ = {};

        dxExecDateValidator: DevExpress.ui.dxValidatorOptions;
        dxCustDateValidator: DevExpress.ui.dxValidatorOptions;

        updatingAccountLadda: boolean = false;
        loadingCustodianAccountsLadda: boolean = false;
        reservingCustodianAccountLadda: boolean = false;
        savingCustodianAccountLadda: boolean = false;
        unlockingAccountNumberLadda: boolean = false;
        uploadingToCustodianLadda: boolean = false;
        openingAccountLadda: boolean = false;
        loadingDoclistLadda: boolean = false;
        cuProposalController: components.common.CuProposalController;
        cuAccount: CuAccountController;

        accountOpened: boolean = false;
        user: domains.identity.IUser;
        reportAppWnd: Window;

        custodianDocuments: domains.ICustodianDocument[] = [];
        selCustodianDocument: domains.ICustodianDocument = {};
        isLaserappPlatform: boolean = false;
        laserAppWnd: Window;
        flagDeletedHoldings: number;
        showDocumentSelection: boolean = false;

        nonCustodianOrg: number = domains.DocumentOrganization.NONCUSTODIAN_SUBSCRIPTION;
        custodianOrg: number = domains.DocumentOrganization.CUSTODIAN;

        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#accountContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading account data...",
            bindingOptions: {
                visible: "vm.isInitializing"
            },
            onShown: function () {
                //setTimeout(function () {
                //    $scope.$apply(function () {
                //        $scope.loadingVisible = false;
                //    });
                //}, 3000);
            },
            onHidden: function () {
                //$scope.employeeInfo = employee;
            }
        };

        static $inject = ["generalService", "advisorService", "identityService", "$scope", "$q", "repGroupApi", "accountApi"];
        constructor(private generalService: services.GeneralService,
            private advisorService: services.AdvisorService,
            private identityService: services.IdentityService,
            private $scope: ng.IScope,
            private $q: ng.IQService,
            private repGroupApi: services.RepGroupApi,
            private accountApi: services.AccountApi) {

            // reload custodians when firm change
            this.$scope.$watch("vm.cuAccount.selAdvisoryFirm.id", () => {
                if (this.cuAccount && this.cuAccount.selAdvisoryFirm && (this.cuAccount.selAdvisoryFirm.id > 0)) {
                    this.loadCustodians(this.cuAccount.selAdvisoryFirm.id);
                } else {
                    this.custodians = [];
                }
            });

            this.fuOptions = {
                bindingOptions: {
                    value: "vm.fuValue",
                    uploadUrl: "vm.uploadUrl"
                },
                //uploadUrl: "/api/advisor/uploadaccountdocument/1014/2",
                selectButtonText: "Select document(s) for upload",
                labelText: " or Drop files here...",
                multiple: true,
                uploadMode: "useButtons", //useButtons instantly
                accept: "*", //"image/*",
                readyToUploadMessage: "Document is ready for upload",
                //buttonText: "Upload documents <br/> Blah",
                uploadButtonText: "Upload selected documents",
                showFileList: true
            };

            this.dxExecDateValidator = {
                validationRules: [
                    { type: "required", message: "Joint Trust Agreement Execution Date is required" }
                ]
            };

            this.dxCustDateValidator = {
                validationRules: [
                    { type: "required", message: "Custodian Gift Date is required" }
                ]
            };

            //console.log("AW_Step", this.AW_Step);
        }

        getProposalStepTitle(): string {
            if (!this.accountOpened) {
                return (this.cuAccount
                    && ((this.cuAccount.hasTamp()
                        && this.cuAccount.selTamp
                        && (this.cuAccount.selTamp.type == domains.TampType.EXTERNAL_TAMP)) || this.cuAccount.hasSubscriptionAgreement()
                    )) ? "Investment setup" : "Investment proposal";
            }
            else {
                return "Account Setup";
            }
        }

        getStepClass(step: number) {
            return (this.step === step) ? "active" : (this.step > step) ? "disabled completed" : "disabled";
        }

        getTabStyleClass(tab: number): string {
            return (tab == this.step) ? "active" : "";
        }

        unlockAccountNumber = (): ng.IPromise<string> => {
            this.unlockingAccountNumberLadda = true;
            return this.advisorService.unlockAccountNumber(this.custodianAccount.id)
                .then(data => {
                    toastr.success("Account number has been unlocked");
                    const tmpAccount = <domains.IAccount>data.data;
                    //this.account.number = tmpAccount.number;
                    this.custodianAccount.isNumberReserved = tmpAccount.isNumberReserved;
                    return data.data;
                }, err => this.generalService.showError(err)).finally(() => {
                    this.unlockingAccountNumberLadda = false;
                });
        };



        createAccount(): ng.IPromise<boolean> {

            this.updatingAccountLadda = true;

            //open account ...
            this.account.titleId = 0;//this.title.id;
            this.account.titleName = "";//this.title.name;
            this.account.usdMarketValue = 0;
            this.account.status = 0;
            this.account.id = 0;

            this.cuAccount.bindAccountFromForm();

            if (this.isCustodialAccount() || this.isAccountTitleJointTenantOrJoinTransferDeath()) {
                this.updatingAccountLadda = false;
                return;
            }

            //console.log("Account u kreiranju: ", this.account);
            //prvo pronaci koji je cekiran investor a onda ga azurirati u title racuna

            // 04 July 18, GL: Commenting this section out, don't think these selections are available at
            // the BASIC_INFORMATION step in the workflow, so no need to set it from selctions.
            //
            // //////////////////////
            // activate account form - the last step
            //if (this.selCustodian)
            //    this.account.custodianId = this.selCustodian.custodianId;
            //else
            //    this.account.custodianId = null;
            //
            //if (this.selOfficeRange)
            //    this.account.officeRangeId = this.selOfficeRange.id;
            //else
            //    this.account.officeRangeId = null;
            //
            //if (this.selRepfeeGroup)
            //    this.account.repFeeGroupId = this.selRepfeeGroup.id;
            //else
            //    this.account.repFeeGroupId = null;

            // ////////////////////////////

            if (this.selectedSkippOption) {
                //this.account.proposal.proposalState = 5;
                this.account.proposal.proposalState = domains.ProposalState.SIGNED;
                this.account.status = 2;
            }

            this.getProposalStepTitle();

            return this.advisorService.openAccount(this.account)
                .then(data => {
                    toastr.success("Account has been successfully created.");
                    this.account = data.data;
                    if (this.cuAccount.selAdvisoryFirm.firmType > domains.FirmType.REGISTERED_INVESTMENT_ADVISOR)
                        this.loadRTQs(this.account.titleId);
                    return true;
                }, err => toastr.error("Account has not been created. Error " + err.data))
                .finally(() => {
                    this.updatingAccountLadda = false;
                });
        };

        resetCustodianAccountData() {

            //console.log("RESETTING CUSTODIAN ACCOUNT DATA");

            // Reset fields on accounts relating to custodian account linkage
            if (this.account.custodianAccountId) {
                this.account.number = "";
            }
            this.account.custodianAccountId = null;
            this.account.isNewCustodianAccount = false;

            // User will need to reload custodian accounts if they want to link to an existing one
            this.custodianAccounts = null;
            this.custodianAccountsSelections = null;

            // Reset custodian account-related form fields
            this.createNewCustodianAccount = false;
            this.custodianAccount.name = null;
            this.selCustodian = null;
            this.officeRanges = null;
            this.selCustStateGiftGiven = null;
            this.selCustMannerOfGift = null;
            this.selSourceOfInitialFunds = null;
            this.selPricingType = null;
            this.selBrokerageType = null;
            this.selSweepStatus = null;
            this.selJointTenancyState = null;
            this.custodianAccount.jointAgreementExecDate = null;
            this.custodianAccount.custStateGiftGiven = null;
            this.custodianAccount.custDateGiftGiven = null;
            this.custodianAccount.custMannerOfGift = null;
            this.custodianAccount.custAgeTermination = null;
            this.custodianAccount.confirmSuppression = null;
            this.custodianAccount.sweepFundsPercent = 0;
            this.custodianAccount.sweepId = null;
            this.custodianAccount.foreignBankAccount = null;
            this.custodianAccount.centralBankAcctInd = null;
            this.custodianAccount.foreignFinInstInd = null;
            this.custodianAccount.marginDebtIndicator = null;
            this.custodianAccount.nonUSOfficial = null;
            this.custodianAccount.usOfficialFirstName = null;
            this.custodianAccount.usOfficialLastName = null;
            this.custodianAccount.usOfficialOfficeHeld = null;
            this.custodianAccount.usOfficialOfficeCountry = null;
            this.custodianAccount.redemptionPriority = null;
            this.custodianAccount.privateBankAccount = null;
            this.custodianAccount.isDocumentationSent = null;
            this.custodianAccount.isNumberReserved = null;
            this.custodianAccount.initialFundsOtherText = null;
            this.custodianAccount.jointTenancyState = null;
            this.custodianAccount.jointHoldersMarried = null;
            this.custodianAccount.extApiTransmitted = null;
            this.custodianAccount.extApiTransmittedStr = null;
        }

        updateAccount(): ng.IPromise<boolean> {

            this.updatingAccountLadda = true;

            this.cuAccount.bindAccountFromForm();

            if (this.selCustodian)
                this.account.custodianId = this.selCustodian.custodianId;
            else
                this.account.custodianId = null;

            if (this.selPricingType)
                this.account.pricingType = this.selPricingType.value;
            else
                this.account.pricingType = null;

            if (this.createNewCustodianAccount)
                this.account.isNewCustodianAccount = true;
            else
                this.account.isNewCustodianAccount = false;

            // If this account is linked to a custodian account, then we need to un-link the account,
            // because the user has changed the investors on this account.
            // Investors need to be the same between the account and custodian account that it is linked to.
            // This unlinks the accounts and resets various form fields.
            if (this.cuAccount.investorsDirty == true) {
                this.resetCustodianAccountData();
                this.cuAccount.investorsDirty = false;
            }

            return this.advisorService.updateAccount(this.account)
                .then(response => {
                    toastr.success("Account has been successfully updated.");
                    this.account = response.data;
                    return true;
                }, err => this.generalService.showError(err))
                .finally(() => this.updatingAccountLadda = false);
        };

        finalSetupAndChecks(): boolean {

            // Custodan account final setup and checks
            if (!this.createNewCustodianAccount) {
                this.account.isNewCustodianAccount = false;
                if (this.selCustodianAccount) {
                    this.account.custodianAccountId = this.selCustodianAccount.id;
                    this.account.number = this.selCustodianAccount.custodianName + "-" + this.selCustodianAccount.number;
                }
            } else {
                this.account.custodianAccountId = this.custodianAccount.id;
                this.account.number = this.custodianAccount.custodianName + "-" + this.custodianAccount.number;
            }

            if (this.isCustodianRequired() && (this.account.custodianAccountId <= 0)) {
                toastr.warning("Please select or create a custodian account.");
                return false;
            }

            // RTG final check
            if (this.account.advisoryFirm.firmType == domains.FirmType.REGISTERED_INVESTMENT_ADVISOR) {
                // outside accounts can be without RTG
                if (this.hasRTGStep()) {
                    let checking = this.checkDoesRtgsAreAssignedToInvestors();
                    if (!checking) {
                        toastr.warning("Please assign RTG for each investor in the account.");
                        return false;
                    }
                }
            }
            else if (this.account.advisoryFirm.firmType == domains.FirmType.BROKER_DEALER) {
                // RTG must be defined on Account Title level
            }
            else {
                // We don't support other options right now
            }

            return true;
        }

        activateAccount(): ng.IPromise<boolean> {
            return this.advisorService.activateAccount(this.account)
                .then((data) => {
                    toastr.success("You have successfully opened the account.");
                    return true;
                }, err => this.generalService.showError(err));
        }

        beneficiariesChanged(){
            //console.log("beneficiariesListChanged");
            this.beneficiariesAreDirty = true;
            this.custodianAccountIsDirty = true;
        }

        beneficiariesSaved() {
            //console.log("beneficiariesListSaved");
            this.beneficiariesAreDirty = false;
        }

        checkDoesRtgsAreAssignedToInvestors(): boolean {
            var forCheck: boolean = true;
            this.account.rtgs.forEach((item, index) => {
                if (!item.accountGroup || item.accountGroup == null || !item.accountGroupId || item.accountGroupId == 0) {
                    forCheck = false;
                }
            })
            if (!forCheck) {
                return false;
            }
            else {
                return true;
            }
        }

        bindCuAccount(ctrl: CuAccountController) {
            this.cuAccount = ctrl;
        }

        bindCuProposal(ctrl: components.common.CuProposalController): void {
            this.cuProposalController = ctrl;
        };

        selectCustodian() {
            this.selCustodian = null;
            this.officeRanges = null;
            if (this.custodians && (this.custodians.length > 0)) {
                var cust = this.custodians.filter((v) => { return v.custodianId == this.account.custodianId; });
                if (cust.length <= 0) return;
                this.selCustodian = cust[0];
                if (this.selCustodian.custodian.hasOfficeRanges) {
                    this.officeRanges = this.selCustodian.officeRanges;
                    if (this.account.officeRangeId <= 0) return;
                    var sor = this.officeRanges.filter((v) => { return v.id == this.account.officeRangeId; });
                    if (sor.length > 0)
                        this.selOfficeRange = sor[0];
                }
            }

        }

        doStep(forward: boolean = true): void {
            let stepBack = !forward;
            //console.log(`Calling doStep ${forward?'forward':'backward'}`);
            if (forward) {
                if (this.step == AW_Step.BASIC_INFORMATION) {
                    if (this.isOutsideInvestmentAccount()) {
                        this.step = AW_Step.DEFINE_OUTSIDE_HOLDINGS;
                    } else if (this.hasRTGStep()) {
                        this.step = AW_Step.DEFINE_RTG;
                    } else {
                        this.step = AW_Step.INVESTMENT_PROPOSAL;
                    }
                }
                else if (this.step == AW_Step.DEFINE_OUTSIDE_HOLDINGS) {
                    if (this.hasRTGStep())
                        this.step = AW_Step.DEFINE_RTG;
                    else {
                        this.$router.navigate(['AdvisorAccounts', { accountStatus: 0 }]);
                        //window.history.back();
                    }
                }
                else if (this.step == AW_Step.DEFINE_RTG) {
                    if (this.isOutsideInvestmentAccount()) {
                        this.$router.navigate(['AdvisorAccounts', { accountStatus: 0 }]);
                    } else if (this.hasProposalStep()) {
                        this.step = AW_Step.INVESTMENT_PROPOSAL;
                    } else {
                        this.step = AW_Step.OPEN_ACCOUNT;
                    }
                }
                else if (this.step == AW_Step.INVESTMENT_PROPOSAL) {
                    this.step = AW_Step.OPEN_ACCOUNT;
                } else if (this.step == AW_Step.OPEN_ACCOUNT) {
                    this.$router.navigate(['AdvisorAccounts', { accountStatus: 0 }]);
                } else {
                    //console.log(`Forward step from ${this.step} has not been defined`);
                }

                //console.log(`Forward to step: ${this.step}`);
            }
            else if (stepBack) {
                if (this.step == AW_Step.DEFINE_OUTSIDE_HOLDINGS) {
                    this.step = AW_Step.BASIC_INFORMATION;
                }
                else if (this.step == AW_Step.DEFINE_RTG) {
                    if (this.isOutsideInvestmentAccount())
                        this.step = AW_Step.DEFINE_OUTSIDE_HOLDINGS;
                    else
                        this.step = AW_Step.BASIC_INFORMATION;
                }
                else if (this.step == AW_Step.INVESTMENT_PROPOSAL) {
                    if (this.hasRTGStep()) {
                        this.step = AW_Step.DEFINE_RTG;
                    } else {
                        this.step = AW_Step.BASIC_INFORMATION;
                    }
                }
                else if (this.step == AW_Step.OPEN_ACCOUNT) {
                    if (this.hasProposalStep())
                        this.step = AW_Step.INVESTMENT_PROPOSAL;
                    else if (this.hasRTGStep())
                        this.step = AW_Step.DEFINE_RTG;
                    else if (this.isOutsideInvestmentAccount())
                        this.step = AW_Step.DEFINE_OUTSIDE_HOLDINGS;
                    else
                        this.step = AW_Step.BASIC_INFORMATION;
                }
                else {
                    //console.log(`Backward step from ${this.step} has not been defined`);
                }

                //console.log(`Go back to step: ${this.step}`);
            }
        };

        isAccountTitleJointTenantOrJoinTransferDeath(): boolean {
            if (this.account.titleType == domains.TitleType.JOINT_TENANT.valueOf() || this.account.titleType == domains.TitleType.JOINT_TRANSFER_ON_DEATH.valueOf()) {

                if (this.account.investors && this.account.investors.length < 2) {
                    toastr.warning("Please select at least two investors for this title type.");
                    return true;
                }
            }
            else {
                return false;
            }
        }

        isCustodialAccount(): boolean {
            if (this.account.titleType === domains.TitleType.CUSTODIAL) {
                if (this.account.investors.length < 2) {
                    toastr.warning("Please select at least two investors for this title type.");
                    return true;
                }
            }
            else {
                return false;
            }
        }

        nextStep(): void {

            if (this.step > AW_Step.OPEN_ACCOUNT) {
                toastr.error("Operation not allowed.");
                return;
            }


            if (this.step == AW_Step.BASIC_INFORMATION) {
                //all data must be validated before next step
                if (!this.cuAccount.validateAccountBasicInformationForm()) return;

                if (this.account.id == 0) {
                    this.createAccount()
                        .then(success => { if (success) this.doStep(); });
                }
                else {
                    this.updateAccount().then(success => {
                        if (success) {
                            //reusing RTG is available only for RIA
                            if (this.cuAccount.selAdvisoryFirm.firmType > domains.FirmType.REGISTERED_INVESTMENT_ADVISOR)
                                this.loadRTQs(this.account.titleId);

                            this.doStep();
                        };
                    });
                }
            } else if (this.step == AW_Step.DEFINE_OUTSIDE_HOLDINGS) {
                if (!this.hasRTGStep()) {
                    if (this.finalSetupAndChecks()) {
                        this.activateAccount().then(success => {
                            if (success) this.doStep();
                        });
                    }
                } else {
                    this.doStep();
                }
            } else if (this.step == AW_Step.DEFINE_RTG) {
                if (this.cuAccount.selAdvisoryFirm.firmType == domains.FirmType.REGISTERED_INVESTMENT_ADVISOR) {
                    if (!this.isRTGCompleted()) {
                        if (this.isOutsideInvestmentAccount()) {
                            toastr.error("Please define RTG for RTG outside investment holdings");
                            return;
                        } else {
                            //toastr.warning("Note: Account RTG has not been set for one or more customers. You can continue with the next step but you will be forced to do that for each of you customers, before they sign proposal of this account.");
                            toastr.warning("Note: Account RTG has not been set for one or more customers.");
                        }
                    }
                } else if (!this.rtq || this.rtq.id <= 0) {
                    //RTQ / RTG for each individual should exists
                    //toastr.warning("Risk Tolernace has not be assigned to this account. You will need to define risk tolerance before the customer can sign the proposal.");
                    toastr.warning("Note: Risk Tolerance has not been assigned to this account.");
                }

                if (this.isOutsideInvestmentAccount()) {
                    // we need to activate account here !?!? since this is the last step for this kind of account
                    toastr.success("Account has been successfully created.");
                }

                this.doStep();
            }
            else if (this.step == AW_Step.INVESTMENT_PROPOSAL) {
                if (this.hasProposal()) {
                    if (!this.cuProposalController.validateProposalForm())
                        return;
                    if (this.enableOpenAccountStep())
                        this.doStep();
                    else {
                        toastr.warning("Either proposal needs to be signed or you need to indicate that Discretion Documentation is on File.");
                    }
                }
                else if (this.hasSubscription()) {
                    this.doStep();
                }
            }
            else if (this.step == AW_Step.OPEN_ACCOUNT) {
                this.openingAccountLadda = true;
                if (this.validateOpenAccountForm()) {
                    if (this.finalSetupAndChecks()) {
                        this.activateAccount().then(success => {
                            if (success)
                                this.doStep();
                        }, err => this.generalService.showError(err)).finally(() => {
                            this.openingAccountLadda = false;
                        });
                    } else {
                        this.openingAccountLadda = false;
                    }
                } else {
                    this.openingAccountLadda = false;
                }
            }
        };

        setExternalHoldings(): ng.IPromise<boolean> {

            //console.log("Account before post.", this.account);

            return this.advisorService.setExternalHoldingsUpdate(this.account)
                .then(response => {
                    this.account = response.data;
                    //toastr.success("You have successfully opened the account.");
                    return true;
                },
                    err => this.generalService.showError(err));
        };

        deleteHoldingsForAccount(): ng.IPromise<boolean> {
            return this.advisorService.deleteHoldingsAccount(this.account)
                .then(response => {
                    this.account = response.data;
                    //toastr.success("Holdings successfully removed from account.")
                    return true;
                },
                    err => this.generalService.showError(err));
        };

        getSubscriptionAgreement(): void {
            this.advisorService.getSubscriptionAgreement(this.account.id, true)
                .then(response => {
                    //console.log("Subscription report URL:", response);
                    this.reportAppWnd = window.open(response.data, "_blank");
                }
                    , err => this.generalService.showError(err));
        }

        // ///////////////////
        // handling events
        rtqSelected(rtq: domains.IRTQ): void {
            this.rtq = rtq;
        };

        rtqCreated(rtq: domains.IRTQ): void {
            toastr.info("RTQ has been saved successfully.");
        };
        proposalCreated(proposal: domains.IProposal): void {

            this.account.proposal = proposal;
            this.account.isDiscretionDocumentationOnFile = proposal.isDiscretionDocumentationOnFile;
        };


        accountStatusChanged(status: boolean): void {
            this.accountOpened = status;
        };

        proposalSigned(proposal: domains.IProposal): void {
            toastr.info("Proposal has been signed. Now you can activate the account.");
            this.account.proposal = proposal; //signed
            this.account.proposal.signedReportFileName = proposal.signedReportFileName;
            this.doStep(true);
        };

        onHoldingsRtgChanged(hasRtgHoldings: any) {
            //console.log("Has holdings:", hasRtgHoldings);
            this.hasRtgHoldings = hasRtgHoldings;
        }

        setCustodianAcctIsDirty(): void {
            if (this.selSweepStatus) {
                if (this.selSweepStatus.value == domains.SweepStatus.NO_SWEEP) {
                    this.sweepIsOn = false;
                    this.custodianAccount.sweepId = null;
                    this.custodianAccount.redemptionPriority = false;
                    this.custodianAccount.sweepFundsPercent = 0;
                } else {
                    this.sweepIsOn = true;
                }
            }
            this.custodianAccountIsDirty = true;
        }

        custodianChanged(): void {
            this.setCustodianAcctIsDirty();
            if (this.selCustodian && this.selCustodian.custodian.hasOfficeRanges)
                this.officeRanges = this.selCustodian.officeRanges;
            else
                this.officeRanges = [];
        }

        // ng-init in form tag for locating child form element. crazzy
        scopeOpenAccountForm: any;
        setOpenFormScope(frm): void {
            this.scopeOpenAccountForm = frm;
        }

        validateOpenAccountForm(): boolean {

            //console.log("Open account form: ", this.scopeOpenAccountForm);
            let formIsValid = this.generalService.validateForm(<ng.IFormController>this.scopeOpenAccountForm["formFinishOpnAccount"]);

            if (!formIsValid)
                toastr.error("Open Account form is not complete. Please fill in required fields");

            
            return formIsValid;
        };

        // //////////////////
        // loading methods
        loadCustodians(advisoryFirmId: number): ng.IPromise<void> {
            return this.advisorService.getCustodiansForAdvisoryFirm(advisoryFirmId)
                .then(data => {
                    this.custodians = data.data;
                    //this.selectCustodian();
                }, err => this.generalService.showError(err));
        };
        
        loadRTQs(titleId: number): void {
            this.advisorService.getRTQs(titleId)
                .success((data) => {
                    this.rtqs = data;
                })
                .error((status, data) => {
                    toastr.error("Error " + status + " " + data);
                });
        };

        loadCustodianAccounts(accountId: number): ng.IPromise<any> {

            if (!accountId)
                return this.$q((resolve, reject) => 0);

            console.log(`Loading CA accounts that could be selected for account ${accountId}`);

            this.loadingCustodianAccountsLadda = true;

            return this.accountApi.getCustodianAccounts(accountId, true)
                .then(response => {
                    this.custodianAccounts = response.data;
                    // Only allow custodian selection dropdown to contain accounts that are open
                    this.custodianAccountsSelections = this.custodianAccounts.filter((v) => { return v.status == domains.AccountStatus.OPEN });
                    //console.log(`CA accounts has been loaded`, this.custodianAccounts);
                    return 1;
                }, err => this.generalService.showError(err)).finally(() => {
                    this.loadingCustodianAccountsLadda = false;
                });
        }

        loadLovs(): void {
            this.generalService.getLOVs()
                .then(data => {
                    this.lovs = data
                    this.custStateGiftGiven = data.filter((value, index, array) => { return value.lovType == domains.LovType.STATES });
                    this.custMannerOfGifts = data.filter(f => f.lovType === domains.LovType.CUST_MANNER_OF_GIFT);
                    this.sourcesOfInitialFunds = data.filter(f => f.lovType === domains.LovType.SOURCE_OF_INITIAL_FUNDS);
                    this.pricingTypes = data.filter(f => f.lovType === domains.LovType.PRICING_TYPE);
                    this.brokerageTypes = data.filter(f => f.lovType === domains.LovType.BROKERAGE_TYPE);
                    this.sweepStatuses = data.filter(f => f.lovType === domains.LovType.SWEEP_STATUS && f.extra2 == "Y"); // extra2 - filter for elements to show when creating an account, at creation time, not all elements apply.
                    this.countries = this.lovs.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 === this.usCountryCode)
                        .concat(this.lovs.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 !== this.usCountryCode));
                    this.jointTenancyState = data.filter((value, index, array) => { return value.lovType == domains.LovType.STATES });
                }, err => this.generalService.showError(err));
        };

        onChangeHoldingsMaintainedExSystem(): void {

            //console.log("Holdings Maintained in External System", this.account.holdingsMaintaindExSystem?"Yes":"No");

           // this.account.holdingsMaintaindExSystem = !this.account.holdingsMaintaindExSystem;

            //if (this.account.holdingsMaintaindExSystem) {

            //    this.setExternalHoldings().then(response => {
            //        toastr.success("Account info updated.");
            //        this.deleteHoldingsForAccount().then(success => {
            //            toastr.success("Holdings related for this account has been deleted.");
            //                this.flagDeletedHoldings = 1;
            //        });
            //    });
            //}
            //else {
            //    this.setExternalHoldings().then(response => {
            //        toastr.success("Account info updated.");
            //        this.flagDeletedHoldings = 0;

            //    });
            //}
        };

        checkIsSelectedProductInactive(accountId: number): void {
            this.advisorService.checkIsProductInactive(accountId)
                .then(response => {
                    if (response.data == false) {
                        toastr.error("Selected product is inactive now, please select new one in first step of opening account.");
                        this.step = AW_Step.BASIC_INFORMATION;
                    }
                })
                .catch(error => {
                    toastr.error("Unable to validate product.");
                })
        };

        checkIsSelectedProductProposalInvestmentModels(accountId: number): void {
            this.advisorService.checkIsProductInactiveForProposalInvestments(accountId)
                .then(response => {

                    if (response.data.length != 0) {
                        response.data.map(v => toastr.error("Selected product: " + v.managerProductName + " is not active, please select other one."));
                        this.step = AW_Step.INVESTMENT_PROPOSAL;
                    }
                })
                .catch(error => {
                    toastr.error("Unable to validate product.");
                })
        };

        loadAccount(accountId: number): ng.IPromise<void> {

            var ctrl = this;

            return this.accountApi.getById(accountId)
                .then(data => {

                    if ((data.data.status != domains.AccountStatus.SETUP)
                        && (data.data.status != domains.AccountStatus.PROPOSED)
                        && (data.data.status != domains.AccountStatus.OPENING)) {
                        toastr.error("This account can not be updated via the wizard because it must be in the SETUP, PROPOSED or OPENING state.");
                        this.$router.navigate(['AdvisorAccounts', { accountStatus: 1 }]);
                        return;
                    }

                    if (data.data.accountType == domains.InvestmentType.CUSTODIAN_ACCOUNT) {
                        toastr.error("You can not directly update a custodian account in the wizard. Please select a linked invesment account.");
                        this.$router.navigate(['AdvisorAccounts', { accountStatus: 1 }]);
                        return;
                    }

                    this.account = data.data;

                    //console.log("LOAD ACCOUNT: ", this.account);

                    if (this.account.accountType == domains.InvestmentType.DIRECT_INVESTMENT)
                        this.checkIsSelectedProductInactive(accountId);

                    if ((this.account.accountType == domains.InvestmentType.MANAGED_MODELS || this.account.accountType == domains.InvestmentType.SMA) && this.account.proposal)
                        this.checkIsSelectedProductProposalInvestmentModels(accountId);

                    if (this.cuAccount) {
                        this.cuAccount.bindAccountForm();
                    }

                    if (this.account.repFeeGroupId > 0) {
                        this.repGroupApi.getById(this.account.repFeeGroupId)
                            .then(data => this.selRepfeeGroup = data.data, err => this.selRepfeeGroup = null);
                    }

                    // Only needed for the account types that use custodians
                    //if (this.account.accountType == domains.InvestmentType.INDIVIDUAL_HOLDINGS
                    //    || this.account.accountType == domains.InvestmentType.MANAGED_MODELS) {
                        this.loadCustodians(this.account.advisoryFirm.id);
                        this.loadCustodianAccounts(this.account.id)
                            .then(response => {
                                // If this account controls creation of a new custodian account
                                if (ctrl.account.isNewCustodianAccount) {
                                    ctrl.createNewCustodianAccount = true;

                                    // If the custodian account record already exists, then allow the user to modify it
                                    if (ctrl.account.custodianAccountId) {
                                        //console.log(`CA has been set to ${ctrl.account.custodianAccountId}`);

                                        // This filter should always find a custodian account since the account custodianAccountId is populated,
                                        // and the integrity should be in place between the account and custodian account (same list of investors and same RTGs for all investors)
                                        // If this filter does not find a custodian account then there is a data problem.
                                        var cacct = ctrl.custodianAccounts.filter((cas) => { return cas.id == ctrl.account.custodianAccountId; });
                                        if (cacct.length > 0) {
                                            ctrl.selCustodianAccount = cacct[0];
                                            ctrl.custodianAccount = cacct[0];

                                            //console.log("CUSTACCT:", ctrl.custodianAccount);

                                            // If the custodian account is open, we can not change it/
                                            // Otherwise, show the create custodian account sub-form, and allow the user to modify the custodian setup
                                            if (ctrl.custodianAccount.status == domains.AccountStatus.OPEN) {
                                                ctrl.createNewCustodianAccount = false;
                                                ctrl.account.isNewCustodianAccount = false;
                                            } else {
                                                // Set all of the custodian selection data
                                                ctrl.selCustodian = null;
                                                ctrl.officeRanges = null;
                                                if (ctrl.custodians && (ctrl.custodians.length > 0)) {
                                                    var cust = ctrl.custodians.filter((v) => { return v.custodianId == ctrl.custodianAccount.custodianId; });
                                                    if (cust.length > 0) {
                                                        ctrl.selCustodian = cust[0];
                                                        if (ctrl.selCustodian.custodian.hasOfficeRanges) {
                                                            ctrl.officeRanges = ctrl.selCustodian.officeRanges;
                                                            if (ctrl.custodianAccount.officeRangeId > 0) {
                                                                var sor = ctrl.officeRanges.filter((v) => { return v.id == ctrl.custodianAccount.officeRangeId; });
                                                                if (sor.length > 0)
                                                                    ctrl.selOfficeRange = sor[0];
                                                            }
                                                        }
                                                    }
                                                }
                                                if (ctrl.custodianAccount.custStateGiftGiven)
                                                    this.selCustStateGiftGiven = this.custStateGiftGiven.filter(v => v.extra1 === ctrl.custodianAccount.custStateGiftGiven)[0];
                                                if (ctrl.custodianAccount.custMannerOfGift)
                                                    this.selCustMannerOfGift = <domains.ILOV>{ value: ctrl.custodianAccount.custMannerOfGift };
                                                if (ctrl.custodianAccount.sourceOfInitialFunds)
                                                    this.selSourceOfInitialFunds = <domains.ILOV>{ extra1: ctrl.custodianAccount.sourceOfInitialFunds };
                                                if (ctrl.custodianAccount.pricingType >= 0)
                                                    this.selPricingType = <domains.ILOV>{ value: ctrl.custodianAccount.pricingType };
                                                if (ctrl.custodianAccount.brokerageType >= 0)
                                                    this.selBrokerageType = <domains.ILOV>{ value: ctrl.custodianAccount.brokerageType };
                                                if (ctrl.custodianAccount.sweepStatus) {
                                                    this.selSweepStatus = this.sweepStatuses.filter(f => f.extra1 === ctrl.custodianAccount.sweepStatus)[0];
                                                    if (this.selSweepStatus && (this.selSweepStatus.value != domains.SweepStatus.NO_SWEEP))
                                                        this.sweepIsOn = true;
                                                    else
                                                        this.sweepIsOn = false;
                                                } else {
                                                    this.sweepIsOn = false;
                                                }
                                                //console.log("ctrl.custodianAccount.sweepStatus:", ctrl.custodianAccount.sweepStatus);
                                                //console.log("SWEEP IS ON:", this.sweepIsOn);
                                                //console.log("this.selSweepStatus:", this.selSweepStatus);
                                                //console.log("this.selSweepStatus.value:", this.selSweepStatus.value);
                                                //console.log("domains.SweepStatus.NO_SWEEP:", domains.SweepStatus.NO_SWEEP);
                                                if (ctrl.custodianAccount.usOfficialOfficeCountry)
                                                    this.selUsOfficialOfficeCountry = <domains.ILOV>{ extra2: ctrl.custodianAccount.usOfficialOfficeCountry };
                                                if (ctrl.custodianAccount.jointTenancyState)
                                                    this.selJointTenancyState = this.jointTenancyState.filter(v => v.extra1 === ctrl.custodianAccount.jointTenancyState)[0];

                                                // If this account has beneficiaries, force re-save of the custodian account because the user may have exited
                                                // this screen earlier after saving beneficiary information, but before saving the custodian account.
                                                if (this.BeneficiariesRequired()) {
                                                    this.custodianAccountIsDirty = true;
                                                } else {
                                                    this.custodianAccountIsDirty = false;
                                                }
                                            }
                                        }
                                    }
                                }
                            })
                    //}
                }, error => this.generalService.showError(error));
        };


        // ///////////////////////
        // calculated properties
        isOutsideInvestmentAccount(): boolean {
            return this.cuAccount && this.cuAccount.isOutsideInvestmentAccount();
        }

        isRIAAccount(): boolean {
            return this.cuAccount && this.cuAccount.selAdvisoryFirm &&
                this.cuAccount.selAdvisoryFirm.firmType == domains.FirmType.REGISTERED_INVESTMENT_ADVISOR;
        }

        isProposalCompleted(): boolean {
            //return (this.account.proposal && (this.account.proposal.proposalState == 5 || this.account.proposal.isDiscretionDocumentationOnFile || this.account.proposal.proposalState == 1));
            return (this.account.proposal && (this.account.proposal.proposalState == domains.ProposalState.SIGNED || this.account.proposal.isDiscretionDocumentationOnFile || this.account.proposal.proposalState == domains.ProposalState.ACTIVE));
        };

        isSetupOnly(): boolean {
            return (this.account.proposal && this.account.proposal.accountSetupOpen);
        };

        allowBeneficiaryChanges(): boolean {
            if (this.custodianAccount && this.custodianAccount.id > 0 && this.custodianAccount.extApiTransmitted)
                return false;
            else
                return true;
        }

        //steps awailability
        hasOutsideInvestmentStep(): boolean {
            return this.isOutsideInvestmentAccount();
        }
        hasRTGStep(): boolean {
            var ret = (((!this.isOutsideInvestmentAccount()) || this.hasRtgHoldings) && !this.isInsuranceProduct());
            return ret;
        }
        hasProposalStep(): boolean {
            return this.cuAccount && (this.cuAccount.hasProposal() || this.cuAccount.hasSubscriptionAgreement());
        }
        hasProposal(): boolean {
            return this.cuAccount && this.cuAccount.hasProposal();
        }
        hasSubscription(): boolean {
            try {
                return this.cuAccount && this.cuAccount.hasSubscriptionAgreement();
            } catch (e) {
                return false;
            }
        }
        hasOpenAccountStep(): boolean {
            return this.hasProposalStep() || this.account.accountType == domains.InvestmentType.CUSTODIAN_ACCOUNT;
        }
        //hasCustodian(): boolean {
        //    return this.cuAccount && this.cuAccount.hasCustodian();
        //}
        isCustodianOptional(): boolean {
            return this.cuAccount && this.cuAccount.isCustodianOptional();
        }
        isCustodianRequired(): boolean {
            var ret = (
                this.createNewCustodianAccount == true ||
                (this.cuAccount && this.cuAccount.isCustodianRequired())
            );
            return ret;
        }
        isPershingAccount(): boolean {
            return this.selCustodian && (this.selCustodian.custodian.name === 'Pershing')
        }

        requireCustodialInfo(): boolean {
            return this.account.titleType == domains.TitleType.CUSTODIAL
        }

        requireJointTrustInfo(): boolean {
            return (this.account.titleType == domains.TitleType.INDIVIDUAL_TRANSFER_ON_DEATH
                || this.account.titleType == domains.TitleType.JOINT_TRANSFER_ON_DEATH)
        }

        requireJointInfo(): boolean {
            return (this.account.titleType == domains.TitleType.JOINT_TENANT
                || this.account.titleType == domains.TitleType.JOINT_TRANSFER_ON_DEATH)
        }

        // steps availability based on Account model not CuAccount control
        _hasOutsideInvestmentStep(): boolean {
            return this.account.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT;
        }
        _hasRTGStep(): boolean {
            return ((this.account.accountType != domains.InvestmentType.OUTSIDE_INVESTMENT)
                && !this.isInsuranceProduct());
        }
        _hasProposalStep(): boolean {
            return (this.account.accountType != domains.InvestmentType.OUTSIDE_INVESTMENT
                && this.account.accountType != domains.InvestmentType.CUSTODIAN_ACCOUNT);
        }
        _hasOpenAccountStep(): boolean {
            return this._hasProposalStep() || this.account.accountType == domains.InvestmentType.CUSTODIAN_ACCOUNT;
       }
        _autoGenerateAccount(): boolean {
            return false;// this.accountGeneralService.hasAutoGeneratedAccount(this.selCustodian.;
        }

        isInsuranceProduct(): boolean {
            return (this.account.productTypeId === domains.ProductType.LIFE_INSURANCE ||
                this.account.productTypeId === domains.ProductType.OTHER_INSURANCE);
        }

        isRTGCompleted(): boolean {
            // for RIA firms
            if (this.account.advisoryFirm.firmType <= 0) {
                for (var i = 0; i < this.account.rtgs.length; i++)
                    if (!this.account.rtgs[i].accountGroupId || this.account.rtgs[i].accountGroupId == 0)
                        return false;
            }
            // for Broker Dealer firms
            else if (this.account.advisoryFirm.firmType > 0 && (!this.rtq || this.rtq.id <= 0))
                return false;
            return true;
        };

        enableOpenAccountStep(): boolean {
            // account and proposal must exist ... unless we are just 'setting up' an already open account,
            // in that case we can also enable the open account step.
            return this.account && this.account.proposal &&
                (this.account.isDiscretionDocumentationOnFile
              || this.account.proposal.proposalState === domains.ProposalState.SIGNED
              || this.account.proposal.proposalState === domains.ProposalState.ACTIVE
                    || (this.account.tampType && (this.account.tampType != domains.TampType.INTERNAL_TAMP))
                    || this.account.proposal.accountSetupOpen);
        }

        skippingOptionChecked(isDiscretionDocumentationOnFile: boolean): void {
            this.selectedSkippOption = isDiscretionDocumentationOnFile;
        }

        //getCustodianDocuments() {
        //    this.createCustodianDocuments();
        //}

        // Currently this is specific to Pershing, we will make this more generic as additional custodians are added to the system.
        // This function takes an optional argument that will reserve an account number before creating/updating the account.
        crtUpdCustodianAcctFromAcct(reserveAcctNumber?: boolean): ng.IPromise<boolean> {

            if (reserveAcctNumber == undefined || reserveAcctNumber == false)
                this.savingCustodianAccountLadda = true;
            else
                this.reservingCustodianAccountLadda = true;

            // Form must be complete in order to invoke this step.
            if (this.validateOpenAccountForm()) {
                this.custodianAccount.cloneAccountId = this.account.id;

                if (this.selCustodian)
                    this.custodianAccount.custodianId = this.selCustodian.custodianId;
                else
                    this.custodianAccount.custodianId = null;

                if (this.selOfficeRange)
                    this.custodianAccount.officeRangeId = this.selOfficeRange.id;
                else
                    this.custodianAccount.officeRangeId = null;

                if (this.selCustStateGiftGiven)
                    this.custodianAccount.custStateGiftGiven = this.selCustStateGiftGiven.extra1;
                else
                    this.custodianAccount.custStateGiftGiven = null;

                if (this.selCustMannerOfGift)
                    this.custodianAccount.custMannerOfGift = this.selCustMannerOfGift.value;
                else
                    this.custodianAccount.custMannerOfGift = null;

                if (this.selRepfeeGroup)
                    this.custodianAccount.repFeeGroupId = this.selRepfeeGroup.id;
                else
                    this.custodianAccount.repFeeGroupId = null;

                if (this.selSourceOfInitialFunds)
                    this.custodianAccount.sourceOfInitialFunds = this.selSourceOfInitialFunds.extra1;
                else
                    this.custodianAccount.sourceOfInitialFunds = null;

                if (this.selPricingType)
                    this.custodianAccount.pricingType = this.selPricingType.value;
                else
                    this.custodianAccount.pricingType = null;

                if (this.selBrokerageType)
                    this.custodianAccount.brokerageType = this.selBrokerageType.value;
                else
                    this.custodianAccount.brokerageType = null;

                if (this.selSweepStatus)
                    this.custodianAccount.sweepStatus = this.selSweepStatus.extra1;
                else
                    this.custodianAccount.sweepStatus = null;

                if (this.selJointTenancyState)
                    this.custodianAccount.jointTenancyState = this.selJointTenancyState.extra1;
                else
                    this.custodianAccount.jointTenancyState = null;

                // force central bank account ind to false if foreign bank account is false
                if (this.custodianAccount.foreignBankAccount == false)
                    this.custodianAccount.centralBankAcctInd = null;

                if (this.custodianAccount.nonUSOfficial == false) {
                    this.custodianAccount.usOfficialFirstName = null;
                    this.custodianAccount.usOfficialLastName = null;
                    this.custodianAccount.usOfficialOfficeHeld = null;
                    this.custodianAccount.usOfficialOfficeCountry = null;
                }
                else {
                    if (this.selUsOfficialOfficeCountry)
                        this.custodianAccount.usOfficialOfficeCountry = this.selUsOfficialOfficeCountry.extra2;
                    else
                        this.custodianAccount.usOfficialOfficeCountry = null;
                }

                if (this.selSourceOfInitialFunds && (this.selSourceOfInitialFunds.extra1 != "OTHR"))
                    this.custodianAccount.initialFundsOtherText = null;

                // Is this account owning creation of the custodian account?
                // If yes, set the attribute on the account
                if (this.createNewCustodianAccount) {
                    this.account.isNewCustodianAccount = true;

                    //console.log("Saving custodian account:", this.custodianAccount);

                    // NOTE: Beneficiaries will be copied from the account to the custodian account on the server...

                    if (reserveAcctNumber == undefined || reserveAcctNumber == false) {
                        return this.advisorService.crtUpdCustodianAcctFromAcct(this.custodianAccount)
                            .then((data) => {
                                toastr.success("Custodian account data has been saved.");
                                this.custodianAccount = <domains.IAccount>data.data;
                                //console.log("CACREATED:", this.custodianAccount);
                                this.account.custodianAccountId = this.custodianAccount.id;
                                this.custodianAccountIsDirty = false;
                                this.savingCustodianAccountLadda = false;
                                return true;
                            }, err => this.generalService.showError(err)).finally(() => {
                                this.savingCustodianAccountLadda = false;
                            });
                    } else {
                        // Normally this attribute would be copied on the server side from the account to the custodian account,
                        // But we will set it here because it is needed to reserve the account number at the custodian,
                        // and this will save us from having to first load the account on the server to get the firm ID. We already know it here.
                        this.custodianAccount.advisoryFirmId = this.account.advisoryFirmId;

                        return this.advisorService.crtUpdCustodianAcctFromAcctWithReserve(this.custodianAccount)
                            .then((data) => {
                                toastr.success("Custodian account data has been saved and account number has been reserved at custodian.");
                                this.custodianAccount = <domains.IAccount>data.data;
                                this.account.custodianAccountId = this.custodianAccount.id;
                                this.custodianAccountIsDirty = false;
                                this.reservingCustodianAccountLadda = false;
                                return true;
                            }, err => this.generalService.showError(err)).finally(() => {
                                this.reservingCustodianAccountLadda = false;
                            });
                    }
                } else {
                    if (reserveAcctNumber == undefined || reserveAcctNumber == false)
                        this.savingCustodianAccountLadda = false;
                    else
                        this.reservingCustodianAccountLadda = false;
                }
            } else {
                if (reserveAcctNumber == undefined || reserveAcctNumber == false)
                    this.savingCustodianAccountLadda = false;
                else
                    this.reservingCustodianAccountLadda = false;
            }
        }

        startCustodianDocuments() {
            if (this.showDocumentSelection == true) {
                this.showDocumentSelection = false;
                return;
            } else {
                this.loadingDoclistLadda = true;
                // Form must be complete in order to invoke this step.
                //this.advisorService.getCustodianDocuments(this.account.custodianId)
                this.advisorService.getCustodianDocuments(this.custodianAccount.custodianId)
                    .then((data) => {
                        this.custodianDocuments = data.data;
                        this.showDocumentSelection = true;
                        //console.log("$ CustodianDocuments", this.custodianDocuments);
                    }).finally(() => {
                        this.loadingDoclistLadda = false;
                    });
            }
        }

        endCustodianDocuments() {
            this.showDocumentSelection = false;
            return;
        }

        uploadAcctDetailsToCustodian() {
            this.uploadingToCustodianLadda = true;
            return this.advisorService.uploadDataToCustodian(this.custodianAccount)
                .then((data) => {
                    toastr.success("You have successfully uploaded the custodian account data to the custodian.");
                    this.custodianAccount = <domains.IAccount>data.data;
                    return true;
                }, err => this.generalService.showError(err)).finally(() => {
                    this.uploadingToCustodianLadda = false;
                });
        }

        CustodianDocumentChanged() {
          if (this.selCustodianDocument.platform === domains.ReportingPlatform.LASERAPP) {
            this.isLaserappPlatform = true;
          } else {
            this.isLaserappPlatform = false;
          }
        }

        // NEW-ACCOUNT-WIZ IS NO LONGER USED, IT IS NOW NEW-NEW-ACCOUNT-WIZ
        generateCustodianDocument() {
          //if (this.selCustodianDocument.platform === domains.ReportingPlatform.LASERAPP) {

          //  this.advisorService.generateLaserAppForm(this.selCustodianDocument.uid, this.custodianAccount.id)
          //    .then(response => {
          //      console.log("Response from LaserApp test:", response);
          //      this.laserAppWnd = window.open(response.data, "_blank");
          //    }
          //      , err => this.generalService.showError(err));

          //  }
        }

        stateCreateRepFee: boolean = false;
        isInEditState: number;
        onChangeNewRepGroup(): void {
            if (this.stateCreateRepFee) {
                this.isInEditState = 1;
            } else {
                this.isInEditState = 0;
            }
        }

        onGroupCreated(event: domains.IRepFeeGroup): void {
            this.stateCreateRepFee = false;
            this.selRepfeeGroup = event;
        }

        checkRightsForCreateNewRepGroup(): boolean {
            if (this.user.role == 'ADVISORY_ADMIN' || this.user.role == 'ADVISORY_LEAD' || this.user.role == 'SERVICER')
                return true;
            return false;
        }

        navigateToCustodianAccountDMS(): void {
            // Documentation tab is tab 7
            this.$router.navigate(['AccountSummary', { accountId: this.custodianAccount.id, NP: 7 }]);
        }

        BeneficiariesRequired() {
            return this.cuAccount.selTitleType &&
                (this.cuAccount.selTitleType.value == domains.TitleType._529_PLAN_ACCOUNT
                    || this.cuAccount.selTitleType.value == domains.TitleType.IRA
                    || this.cuAccount.selTitleType.value == domains.TitleType.INDIVIDUAL_TRANSFER_ON_DEATH
                    || this.cuAccount.selTitleType.value == domains.TitleType.JOINT_TRANSFER_ON_DEATH);
        }

        // overrides ...
        $onInit(): void {
            this.identityService.getUserPromise().then(response => {
                this.user = response;
            });
            this.loadLovs();
        };

        $routerOnActivate(next, previous) {
            if (next.params.accountId) {
                this.isInitializing = true;
                return this.loadAccount(<number>next.params.accountId)
                    .then(data => {

                        this.isInitializing = false;

                        //console.log("Account u new wiz: ", this.cuAccount);

                        //this is not true in all situations
                        if (this._hasOutsideInvestmentStep()) {
                            this.step = AW_Step.DEFINE_OUTSIDE_HOLDINGS;
                        }
                        else if (!this.isRTGCompleted() && this._hasRTGStep()) {
                            //toastr.warning("Account RTG has not been set for one or more customers. You can continue with the next step but you will be forced to do that for each of you customers, before they sign proposal of this account.");
                            toastr.warning("Note: Account RTG has not been set for one or more customers.");
                            this.step = AW_Step.DEFINE_RTG;
                        }
                        else if (!this.isSetupOnly() && !this.isProposalCompleted() && this._hasProposalStep()) {

                            // Commenting this out for now... would like to uncomment this but currently
                            // seems to have a concurrency issue where it is printing the wrong message.
                            //if (this.hasSubscription())
                            //    toastr.warning("Please make sure that you have signed Account Opening Documentation before you open account.");
                            //else 
                            //    toastr.warning("Please sign proposal before you open the account.");

                            toastr.warning("Please obtain signed documentation before you open the account.");

                            this.step = AW_Step.INVESTMENT_PROPOSAL;
                        }
                        else if (this._hasOpenAccountStep()) {
                            //toastr.warning("Please enter data if required and open the account.");
                            this.step = AW_Step.OPEN_ACCOUNT;
                        }
                        else {
                            toastr.error("You are not allowed to perform this action.");
                            this.$router.navigate(['AdvisorAccounts', { accountStatus: 1 }]);
                        }
                    });
            };
        };
    }





    class NewAccountWiz implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        $canActivate;

        //static $inject = ["advisorService"];
        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = NewAccountWizController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/new-account-wiz.html';
            this.$canActivate = ["advisorService", (advisorService: services.AdvisorService) => {
                if (advisorService.isAdminModeEnabled()) {
                    toastr.info("Please exit from Admin Mode to enable account wizard");
                    return false;
                }
                return true;
            }];
        }
    }
    angular.module(Constants.APP).component("newAccountWiz", new NewAccountWiz());
}